import { useCallback, useMemo } from "react";
import { useHistory, useLocation } from "react-router-dom";

export function useSearchParams() {
  const location = useLocation();
  const history = useHistory();
  const searchParams = useMemo(() => new URLSearchParams(location.search), [
    location.search
  ]);

  const updateSearchParams = useCallback(
    newSearchParams => {
      history.push({ search: newSearchParams.toString() });
    },
    [history]
  );

  const replaceSearchParams = useCallback(
    newSearchParams => {
      history.replace({ search: newSearchParams.toString() });
    },
    [history]
  );

  const clearSearchParams = useCallback(() => {
    history.replace({ search: undefined });
  }, [history]);

  return {
    searchParams,
    updateSearchParams,
    replaceSearchParams,
    clearSearchParams
  };
}
